import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;
export const Column = styled.div`
  flex: 1;
  padding: 16px;
  width: 50%;
`;

export const Border = styled.div`
  border: 2px dashed #e5e7eb;
`;

export const Box = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  border-style: dashed;
  border-width: 1px;
  border-radius: 0.5rem;
  padding: 1rem;
`;

export const TextRed = styled.span`
  color: red;
`;

export const VoiceIndicator = styled.div`
  width: 80px;
  display: flex;
  justify-content: center;
  padding: 1rem;
  border-left: 2px dashed #e5e7eb;
`;
